import Checkout from './checkout';
import CompanyDetailsModal from './CompanyDetailsModal';
import MenuItemsModal from './MenuItemsModal';
import MultiPromoCodeModal from './MultiPromoCodeModal';
import NutritionInfo from './NutritionInfo';
import OtpVerificationModal from './OtpVerificationModal';
import LoginModal from './LoginModal';
import MenuItemModal from './MenuItemModal';
import OrderMethod from './order-method';
import Marketing from './marketing';
import RestaurantClosed from './restaurant-closed';
import OrderBasket from './order-basket';
import OfferModal from './OfferModal';
import FreeItemsModal from './FreeItemsModal';
import EligibleOffersModal from './EligibleOffersModal';
import MobileAppSignupBonusModal from './MobileAppSignupBonusModal';
import BuyGiftCardModal from './BuyGiftCardModal';
import AddPromoOrGiftCardModal from './AddPromoOrGiftCardModal';

export default {
  Checkout,
  CompanyDetailsModal,
  MenuItemsModal,
  MultiPromoCodeModal,
  OrderMethod,
  NutritionInfo,
  OtpVerificationModal,
  LoginModal,
  MenuItemModal,
  Marketing,
  RestaurantClosed,
  OrderBasket,
  OfferModal,
  FreeItemsModal,
  EligibleOffersModal,
  MobileAppSignupBonusModal,
  BuyGiftCardModal,
  AddPromoOrGiftCardModal,
};
